import { formatCompactINR, formatINR, formatNum } from "../../lib/format";
import { GitCompareArrows } from "lucide-react";

const META = "#38BDF8";
const GOOGLE = "#818CF8";

function Row({ label, meta, google, fmt, better }) {
  // better: 'low' or 'high' - which is winner
  let winner = null;
  if (better && meta != null && google != null) {
    if (better === "low") winner = meta < google ? "meta" : "google";
    else winner = meta > google ? "meta" : "google";
  }
  return (
    <tr className="border-b border-white/5">
      <td className="py-2.5 px-2 text-slate-400 text-xs uppercase tracking-wider">{label}</td>
      <td className={`py-2.5 px-2 text-right tabular ${winner === "meta" ? "text-[#10B981] font-semibold" : "text-slate-200"}`}>
        {fmt(meta)}
      </td>
      <td className={`py-2.5 px-2 text-right tabular ${winner === "google" ? "text-[#10B981] font-semibold" : "text-slate-200"}`}>
        {fmt(google)}
      </td>
    </tr>
  );
}

export default function PlatformComparison({ comparison }) {
  if (!comparison) return null;
  const meta = comparison.find((c) => c.platform === "meta") || {};
  const google = comparison.find((c) => c.platform === "google") || {};

  return (
    <div data-testid="platform-comparison" className="rounded-xl bg-[#1E293B] border border-white/10 p-6 h-full">
      <div className="flex items-center gap-2 mb-5">
        <GitCompareArrows className="w-5 h-5 text-[#38BDF8]" />
        <h2 className="font-display text-lg font-semibold">Meta vs Google</h2>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left py-2 px-2 text-xs text-slate-500 font-medium">Metric</th>
            <th className="text-right py-2 px-2">
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold" style={{ color: META }}>
                <span className="w-2 h-2 rounded-full" style={{ background: META }} /> Meta
              </span>
            </th>
            <th className="text-right py-2 px-2">
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold" style={{ color: GOOGLE }}>
                <span className="w-2 h-2 rounded-full" style={{ background: GOOGLE }} /> Google
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <Row label="Spend" meta={meta.spend} google={google.spend} fmt={formatCompactINR} />
          <Row label="Impressions" meta={meta.impressions} google={google.impressions} fmt={formatNum} />
          <Row label="Clicks" meta={meta.clicks} google={google.clicks} fmt={formatNum} />
          <Row label="CTR %" meta={meta.ctr} google={google.ctr} fmt={(v) => `${v}%`} better="high" />
          <Row label="CPC" meta={meta.cpc} google={google.cpc} fmt={formatINR} better="low" />
          <Row label="Leads" meta={meta.leads} google={google.leads} fmt={formatNum} better="high" />
          <Row label="CPL" meta={meta.cpl} google={google.cpl} fmt={formatINR} better="low" />
          <Row label="Conv. Rate" meta={meta.conversion_rate} google={google.conversion_rate} fmt={(v) => `${v}%`} better="high" />
          <Row label="ROAS" meta={meta.roas} google={google.roas} fmt={(v) => `${v}x`} better="high" />
        </tbody>
      </table>
      <p className="text-xs text-slate-500 mt-4">
        <span className="text-[#10B981]">Green</span> highlights the winning channel per metric.
      </p>
    </div>
  );
}
